import { Client } from '@sentry/types';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer?: Array<Record<string, any>>;
    Sentry?: Client;
  }
}

const isDev = process.env.NODE_ENV === 'development';

export const trackEvent = (payload: Record<string, string | number | boolean>) => {
  if (typeof window !== 'undefined' && window.dataLayer && !isDev) {
    window.dataLayer.push(payload);
  }
};

const INNSKRANING_EVENT_NAME = 'registrationSteps';

export enum InnskraningAnalyticsStepEnum {
  // Step 1
  LOGIN_PAGELOAD = 1,
  LOGIN_BUTTON_CLICK = 1.5,

  // Step 2
  ADDRESS_PAGELOAD = 2,
  ADDRESS_REMOVE_BUTTON_CLICK = 2.1,
  ADD_ADDRESS_PAGELOAD = 2.2,
  ADD_ADDRESS_SEARCH_BUTTON_CLICK = 2.3,
  ADD_ADDRESS_ADD_BUTTON_CLICK = 2.4,

  // Step 3
  SUMMARY_PAGELOAD = 3,
  SUMMARY_BUTTON_CLICK = 3.1,

  // Step 4
  SIGNATURE_PAGELOAD = 4,
  SIGNATURE_START_BUTTON_CLICK = 4.1,
  SIGNATURE_IFRAME_LOADED = 4.2,

  // Step 5
  SUCCESS_PAGELOAD = 5,
}

const getInnskraningEventState = (): Array<InnskraningAnalyticsStepEnum> => {
  const currentStateUnParsed = sessionStorage.getItem(INNSKRANING_EVENT_NAME);

  if (currentStateUnParsed) {
    const currentState = JSON.parse(
      currentStateUnParsed
    ) as Array<InnskraningAnalyticsStepEnum>;

    return currentState;
  }

  return [];
};

const clearInnskraningEventState = () => {
  sessionStorage.removeItem(INNSKRANING_EVENT_NAME);
};

const setInnskraningEventState = (step: InnskraningAnalyticsStepEnum) => {
  if (step === InnskraningAnalyticsStepEnum.SUCCESS_PAGELOAD) {
    clearInnskraningEventState();
    return;
  }

  const currentState = getInnskraningEventState();

  if (currentState.includes(step)) {
    return;
  }

  currentState.push(step);
  sessionStorage.setItem(INNSKRANING_EVENT_NAME, JSON.stringify(currentState));
};

export function trackInnskraningEvent(
  step: InnskraningAnalyticsStepEnum,
  payload?: Record<string, string | number | boolean | Array<string>>
) {
  setInnskraningEventState(step);

  trackEvent({
    event: INNSKRANING_EVENT_NAME,
    step,
    ...(payload || {}),
  });
}
